module.exports = __webpack_public_path__ + "static/media/crx8.bf5801ab.png";